import { useStore } from "vuex";
import API from "../api/api-main";
import { useShiftStore } from "../stores/shiftStore";
import { useUserStore } from "../stores/user"


export default async function shifts({ next, router }) {
  const shiftStore = useShiftStore()
  const permissions = useUserStore();
  if (!permissions.checkPermissions("Pos_Shift_Create") && !permissions.checkPermissions("EndShift_Read")) {
    return router.push({ name: 'accessDenied' });
  } else {
    try {
      const res = await API.get(`Shift/GetShiftByUser`);
      shiftStore.addShift(res.data.shift)

      if (res.data.shift) {
        return next();
      }
      return router.push({ name: 'open-shifts' });
    } catch (error) {
      console.error("Lỗi khi gọi API:", error);
    }
  }

}
